import { useRequest } from 'ahooks'

import { toast } from '$app/utilities'

import api from '$model/api'

import { AppClientID } from '$api/types'

export const useAppDetail = (client_id?: AppClientID) => {
  return useRequest(
    async () => {
      const { appDetail, successResolver } = api.value.auth

      if (!client_id) return

      return appDetail({ client_id }).then(successResolver)
    },
    {
      // https://github.com/alibaba/hooks/issues/2356#issue-1977838612
      cacheKey: `app-detail:${client_id}`,
      refreshDeps: [client_id],
      onError: err => toast.error(api.value.auth.errorMessageResolver(err))
    }
  )
}

export default useAppDetail
